import {Component, Input, OnInit} from '@angular/core';
import {CssPositionEnum} from '../../../enums/CssPositionEnum';

@Component({
  selector: 'app-spinner-circle',
  templateUrl: './spinner-circle.component.html',
  styleUrls: ['./spinner-circle.component.scss'],
})
export class SpinnerCircleComponent implements OnInit {
  @Input() size: string = '1.5rem';
  @Input() position: CssPositionEnum = CssPositionEnum.UNSET;
  public elements: number[] = [];
  private elementsCount: number = 12;

  ngOnInit(): void {
    this.elements = Array.from({length: this.elementsCount}, (_, i) => i + 1);
  }
}
